import { USER_LOGOUT } from 'ggApp/modules/auth/actionTypes';
import { shutdownIntercom } from 'ggApp/modules/intercom/service';
import CookiesManager from 'ggApp/utils/CookiesManager';
import { resetUserForBraze } from '../../packages/braze/api';

const isServer = __IS_SERVER__;

export default function logoutMiddleware() {
    return (next) => (action) => {
        if (!isServer) {
            const cookiesManager = new CookiesManager();
            const { type } = action;

            if (type === USER_LOGOUT) {
                cookiesManager.remove('user_id', { path: '/' });
                shutdownIntercom();
                resetUserForBraze();
            }
        }
        next(action);
    };
}
